import React, { ChangeEventHandler } from "react";
import { InputBaseProps } from "..";
import { SanityInputTextProps } from "../../../models/form/SanityFormInputField";
import {
  isNullOrWhiteSpace,
  isPositiveNumber,
  stripNonNumber
} from "../../../shared/string";
import { CustomValidatorFunction } from "../Validation";
import GenericTextInput from "./GenericTextInput";

export type NumberProps = InputBaseProps<SanityInputTextProps>;

const numberValidator: CustomValidatorFunction = (value, translations) => {
  // Note: limited to positive integers. If we need decimals or negatives, we should
  // add options to enable and disable it in Sanity and add parsing of "," to "." for decimal points.
  if (
    typeof value === "string" &&
    !isNullOrWhiteSpace(value) &&
    !isPositiveNumber(value.trim())
  ) {
    return translations.invalidNumber ?? "Invalid number";
  }
};

export const stripNonNumberOnChange: ChangeEventHandler<HTMLInputElement> = e => {
  e.target.value = stripNonNumber(e.target.value);
};

/**
 * A text input that only allows numbers.
 * Using type="number" causes some issues with state in Firefox (letters count as undefined but are still visible).
 */
const Number = (props: NumberProps) => (
  <GenericTextInput
    {...props}
    customValidator={numberValidator}
    inputMode="numeric" // number keyboard on mobile, but still string input for validation
    onChange={stripNonNumberOnChange}
    type="text"
  />
);

export default Number;
